import { effect, inject } from '@angular/core';
import { patchState, Prettify, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { CartsStore } from '../data-stores';
import { withCart } from './features/withCart';
import { withCartPricing } from './features/withCartPricing';

export const CartComponentStore = signalStore(
  { providedIn: 'root' },
  withState({
    _selectedCartId: 'active',
  }),
  withCart(),
  withCartPricing(),
  withMethods((store) => {
    const selectCart = (id: string | undefined | null) => {
      patchState(store, { _selectedCartId: id || 'active' });
    };
    return {
      selectCart,
    };
  }),
  withHooks((store) => {
    const cartsStore = inject(CartsStore);
    return {
      onInit() {
        effect(() => {
          const selectedCartId = store._selectedCartId();
          if (selectedCartId === 'main') {
            store._selectCartById(cartsStore.mainCartId());
          } else if (selectedCartId === 'active') {
            store._selectCartById(cartsStore.activeCartId());
          } else {
            store._selectCartById(selectedCartId);
          }
        });
      },
    };
  }),
);

export type CartComponentStore = Prettify<InstanceType<typeof CartComponentStore>>;
